export default {
  SET_JUDICIAL_LAWSUIT_QUERY (state, query) {
    const current = state.query
    if (query && current && query.id === current.id && query.is_processing && !current.is_processing) return
    state.query = query
  },
  SET_JUDICIAL_LAWSUITS (state, lawsuits) {
    state.lawsuits = lawsuits
  },
  SET_JUDICIAL_LAWSUITS_PAGINATION (state, pagination) {
    state.pagination = pagination
  },
  SET_LOADING_JUDICIAL_LAWSUIT_QUERY (state, isLoading) {
    state.isLoadingQuery = isLoading
  },
  SET_LOADING_JUDICIAL_LAWSUITS (state, isLoading) {
    state.isLoadingLawsuits = isLoading
  },
  SET_CREATING_JUDICIAL_LAWSUIT_QUERY (state, isCreating) {
    state.isCreatingQuery = isCreating
  },
  SET_JUDICIAL_LAWSUIT_DETAIL (state, detail) {
    state.detail = detail
  },
  SET_LOADING_JUDICIAL_LAWSUIT_DETAIL (state, isLoading) {
    state.isLoadingDetail = isLoading
  },
  SET_JUDICIAL_LAWSUIT_ERROR (state, error) {
    state.error = error
  },
  CLEAR_JUDICIAL_LAWSUITS (state) {
    state.query = null
    state.lawsuits = []
    state.pagination = null
    state.detail = null
    state.error = null
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/judicial_lawsuits/mutations.js